import { Route, Router, Switch } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import history from 'service/customHistory';
import PublicNavBar from 'components/other/PublicNavBar/PublicNavBar';
import { clientLite } from 'common/util/gqlRequest';
import PublicRouteStateManager from 'components/common/Managers/PublicRouteStateManager';
import PublicRouter from 'components/common/Router/PublicRouter';

function PublicApp(): JSX.Element {
  return (
    <ApolloProvider client={clientLite}>
      <Router history={history}>
        <PublicRouteStateManager />
        <PublicNavBar />
        <Switch>
          <Route>
            <PublicRouter />
          </Route>
        </Switch>
      </Router>
    </ApolloProvider>
  );
}

export default PublicApp;
